import * as mutation from "./mutation-types";
import * as action from "./action-types";
import { deepCopy, deepCopyAxiosException } from "@/store/helpers";
import { tableHelper } from "@/helpers/table.helper";
import axios from "axios";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";

export const actions = {
  async [action.LIST]({ commit, state }, payload) {
    commit(mutation.LIST_STARTED);
    try {
      const url = tableHelper.constructUrl(payload.endpoint, state.listing.paging, state.listing.criteria);
      const { headers, data } = await axios.get(url);
      commit(mutation.LIST_SET_CRITERIA_DESCRIPTION, tableHelper.getCriteriaInfo(headers));
      commit(mutation.LIST_SET_PAGING, tableHelper.getPagingFromHeaders(headers));
      commit(mutation.LIST_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.LIST_FAILED, deepCopyAxiosException(e));
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.EXPORT]({ commit, state }, payload) {
    commit(mutation.EXPORT_STARTED);
    try {
      await axios.get(tableHelper.constructUrl(payload.exportValidateEndpoint, state.listing.criteria));
      const url = tableHelper.constructUrl(payload.exportEndpoint, state.listing.criteria);
      tableHelper.downloadExportedSpreadsheet(url);
      commit(mutation.EXPORT_SUCCEEDED);
      return true;
    } catch (e) {
      commit(mutation.EXPORT_FAILED, deepCopyAxiosException(e));
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  }
};
